var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{class:[
        'a-select form-select',
        'bg-transparent border-white min-w-[250px] outline-0 px-6 py-3 rounded-[63px]' ],attrs:{"id":_vm.id,"name":_vm.name},on:{"change":_vm.handleChange}},_vm._l((_vm.options),function(o,idx){return _c('option',{key:idx,staticClass:"text-dark",domProps:{"value":o.value}},[_vm._v("\n        "+_vm._s(o.label)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }